module.exports = __webpack_public_path__ + "img/five_stars_bottom.875b912d.jpg";